<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialog"
      :persistent='true'
      width="30%"
      height="100%"
      class="modalDialog"
      no-click-animation
    >
      <CardTitle :title="pageTitle" />
      <v-card-actions class="cardWrap__scroll">
        <v-container>
          <v-form
            class="cardWrap__fromArea"
            ref="form"
            v-model="valid"
          >
            <v-row justify="space-around" class="formHeight">
              <div class="cardWrap__fromArea__title">区分</div>
                <v-text-field
                  v-model="fromSetData.cancel_code_name"
                  :rules="[actionrules.checkEmpty]"
                  maxlength="50"
                />
            </v-row>
            <v-row>
              <div class="cardWrap__fromArea__title">キャンセルポリシー</div>
                <v-textarea
                  v-model="fromSetData.cancel_detail"
                  :rules="[actionrules.checkEmpty]"
                  auto-grow
                  rows="10"
                />
            </v-row>
            <v-row justify="start">
              <div class="cardWrap__fromArea__title">有効フラグ</div>
                <v-checkbox v-model="fromSetData.valid_flag" class="mx-2" label="有効フラグ" />
            </v-row>
          </v-form>
        </v-container>
      </v-card-actions>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="green darken-4" text @click="CloseModal">閉じる</v-btn>
        <v-btn color="green darken-4" text v-if="addModeStatus" @click="RegistCancelPolicy">登録</v-btn>
        <v-btn color="green darken-4" text v-if="changeModeStatus" @click="UpdateCancelPolicy">変更</v-btn>
      </v-card-actions>
    </v-dialog>
  </v-row>
</template>

<script>
import CardTitle from '@/components/module/CardTitle';
import validater from '../../../../lib/validater';
import { UPDATE_CANCEL_POLICY_MASTER, REGISTER_CANCEL_POLICY_MASTER } from '@/constants/cancelpolicy';

export default {
    components: {
        CardTitle
    },
    data () {
        return {
            pageTitle: null,
            dialog: false,
            changeModeStatus: false,
            addModeStatus: false,
            valid: true,
            actionrules: {
                checkEmpty: value => validater.checkEmptyString(value) || this.$t('error.validation.required.any')
            },
            fromSetData: {
                valid_flag: null,
                cancel_code_name: null,
                cancel_detail: null,
                cancel_code: null,
                golf_code: null,
                golf_group_code: null
            }
        };
    },
    methods: {
    /** ----------------------------------------------
     * 初期表示時処理
     * ---------------------------------------------- */
        Initialize () {
            this.addModeStatus = false;
            this.changeModeStatus = false;
            this.addOverlay = false;
            this.changeOverlay = false;
            this.fromSetData = {
                valid_flag: '',
                cancel_code_name: '',
                cancel_detail: '',
                cancel_code: '',
                golf_code: '',
                golf_group_code: ''
            };
        },
        /** ----------------------------------------------
         * 変更
         * ---------------------------------------------- */
        UpdateCancelPolicy: async function () {
            if (this.$refs.form.validate()) {
                try {
                    await this.$apollo.mutate({
                        mutation: UPDATE_CANCEL_POLICY_MASTER,
                        variables: {
                            golf_group_code: process.env.VUE_APP_GROUP_CODE,
                            golf_code: this.fromSetData.golf_code,
                            cancel_code_name: this.fromSetData.cancel_code_name,
                            cancel_code: this.fromSetData.cancel_code,
                            cancel_detail: this.fromSetData.cancel_detail,
                            valid_flag: this.fromSetData.valid_flag
                        }
                    }).then(res => {
                        this.dialog = false;
                        this.$emit('from-Dialog');
                    });
                } catch (error) {
                    this.error = error;
                }
            }
        },
        /** ----------------------------------------------
         * 追加
         * ---------------------------------------------- */
        RegistCancelPolicy: async function () {
            if (this.$refs.form.validate()) {
                try {
                    await this.$apollo.mutate({
                        mutation: REGISTER_CANCEL_POLICY_MASTER,
                        variables: {
                            golf_group_code: process.env.VUE_APP_GROUP_CODE,
                            golf_code: this.fromSetData.golf_code,
                            cancel_code_name: this.fromSetData.cancel_code_name,
                            cancel_detail: this.fromSetData.cancel_detail,
                            valid_flag: this.fromSetData.valid_flag
                        }
                    }).then(res => {
                        this.dialog = false;
                        this.$emit('from-Dialog');
                    });
                } catch (error) {
                    this.error = error;
                }
            }
        },
        /** ----------------------------------------------
         * 親画面にて「追加」ボタン押下時の処理
         * ---------------------------------------------- */
        AddModal (golfCode) {
            this.Initialize();
            this.pageTitle = 'キャンセルポリシー登録';
            this.fromSetData.golf_code = golfCode;
            this.fromSetData.valid_flag = 1;
            this.dialog = true;
            this.addModeStatus = true;
            // フォームがDOMに反映されるまで待つ
            this.$nextTick(function () {
                this.$refs.form.resetValidation();
            });
        },
        /** --------------------------------------------
        * モーダル画面を表示
        * -------------------------------------------- */
        EditModal (item) {
            this.Initialize();
            this.pageTitle = 'キャンセルポリシー編集';
            this.fromSetData.valid_flag = item.valid_flag;
            this.fromSetData.cancel_code_name = item.cancel_code_name;
            this.fromSetData.cancel_detail = item.cancel_detail;
            this.fromSetData.golf_group_code = item.golf_group_code;
            this.fromSetData.golf_code = item.golf_code;
            this.fromSetData.cancel_code = item.cancel_code;
            this.changeModeStatus = true;
            this.dialog = true;
        },
        /** ----------------------------------------------
         * モーダル画面を閉じる際の処理
         * ---------------------------------------------- */
        CloseModal () {
            this.dialog = false;
            this.$emit('from-Dialog');
            this.Initialize();
        }
        /* CloseModals () {
            this.dialog = false;
            this.$refs.form.resetValidation();
            this.$emit('from-Dialog', this.FriendPlayerInfo);
            this.Initialize();
        } */
    }
};
</script>

<style scoped>

.formHeight{
  max-height: 60px;
  max-width: 100%;
}

</style>
